import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { dictionaries, getByPath, format } from "@/lib/i18n";

const STORAGE_KEY = "vardhan.lang";

const LanguageContext = createContext({
    lang: "en",
    setLang: () => {},
    ready: false,
    t: (k) => k,
});

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(null); // null => not chosen yet
    const [ready, setReady] = useState(false);

    useEffect(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            if (saved === "en" || saved === "hi") {
                setLangState(saved);
            }
        } catch (_) {
            /* ignore */
        }
        setReady(true);
    }, []);

    const setLang = useCallback((next) => {
        setLangState(next);
        try {
            localStorage.setItem(STORAGE_KEY, next);
        } catch (_) {
            /* ignore */
        }
        // Update <html lang="..">
        if (typeof document !== "undefined") {
            document.documentElement.setAttribute("lang", next);
        }
    }, []);

    useEffect(() => {
        if (lang && typeof document !== "undefined") {
            document.documentElement.setAttribute("lang", lang);
        }
    }, [lang]);

    const t = useCallback(
        (key, params) => {
            const active = lang || "en";
            const val = getByPath(dictionaries[active], key);
            if (val === undefined) return key;
            if (typeof val === "string") return format(val, params);
            return val;
        },
        [lang],
    );

    return (
        <LanguageContext.Provider value={{ lang: lang || "en", setLang, ready, chosen: !!lang, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLang = () => useContext(LanguageContext);
